import React from 'react';
import bg from '../../assets/images/friendzonelome-27.jpg';
import FAQ from '../../components/FAQ/FAQ';
import EscapeFomo from '../../components/EscapeFomo/EscapeFomo';


const About = () => {
  return (
    <div className="flex justify-center items-center w-full">
      <div className='flex flex-col gap-[80px] bg-offwhite md:max-w-[600px] lg:max-w-[950px] xl:max-w-[1400px] w-full overflow-x-hidden'>

        <div className='flex flex-col w-full lg:gap-10 gap-5'>
          <p className="lg:text-[65px] text-[16px] font-chido">
            ABOUT LAFRIENDZONE
          </p>

          <p className="font-concretica lg:text-[32px] text-[14px]">
            LaFriendzone est une plateforme de divertissement alternative et itérative, où nous célébrons les générations Y et Z, la communauté créative de l’ère numérique et le lifestyle afro.
            <br />
            Chaque édition est un tremplin vers une euphorie générationnelle, des expériences uniques et une créativité sans limites. Un melting-pot favorisant l’inclusion sociale à travers des productions immersives et intemporelles de musique afro, d’art et de lifestyle. Nous encourageons la collaboration entre créateurs, marques et notre communauté, créant ainsi un espace de convergence unique et dynamique.
            <br />
            Depuis octobre 2020, LaFriendzone orchestre 3 à 4 évènements épiques par an, rassemblant à ce jour plus de 20 000 personnes issues de l’Afrique de l’Ouest et de sa diaspora.
          </p>
        </div>

        <div className="flex lg:gap-[25px] gap-2.5 lg:h-[600px] h-[200px] md:h-[300px] w-full lg:border-[6px] border-[4px] border-offblack lg:rounded-[20px] rounded-[5px] bg-cover bg-top" style={{ backgroundImage: `url(${bg})` }} />

        <FAQ />

        <EscapeFomo />

      </div>
    </div>
  )
}

export default About